module.exports = __webpack_public_path__ + "media/src/images/favicon-16x16-8f5fd365aad8ee973184947783bcbacf.png";